var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "choose-language-popup" }, [
    _c(
      "div",
      {
        staticClass: "choose-language-dialog",
        attrs: {
          "data-aos": "fade-up",
          "data-aos-anchor-placement": "center-bottom",
          "data-aos-duration": "400"
        }
      },
      [
        _c("img", {
          attrs: {
            src: require("@/drc/assets/icons/x_white.svg"),
            alt: "close-icon"
          },
          on: { click: _vm.closeDialog }
        }),
        _c(
          "div",
          { staticClass: "error-report-container" },
          [
            _c("h3", [
              _c("img", {
                staticClass: "wave-hand-icon",
                attrs: {
                  src: require("@/common/assets/icons/waving-hand.svg"),
                  alt: "wave-hand-icon"
                }
              }),
              _vm._v(" " + _vm._s(_vm.$t("common.welcome")) + " ")
            ]),
            _c("span", [_vm._v(_vm._s(_vm.$t("common.welcomeText")))]),
            _c("CommonSelect", {
              attrs: {
                "form-data": _vm.formData,
                field: "country",
                label: _vm.$t("common.country"),
                placeholder: _vm.$t("common.countryPlaceholder"),
                options: _vm.dropdownData.countries,
                "text-field-name": "name",
                errorLabel: _vm.$t("common.countryError"),
                imageUrl: "common/assets/icons/countries/",
                isMultiple: false
              },
              on: { selectedOption: _vm.checkError }
            }),
            _vm.formSubmittedEmpty
              ? _c("div", { staticClass: "form-empty-warning" }, [
                  _vm._v(_vm._s(_vm.$t("common.countryError")))
                ])
              : _vm._e(),
            _c("div", { staticClass: "buttons-container" }, [
              _c(
                "button",
                {
                  staticClass: "cancel-button button",
                  on: { click: _vm.closeDialog }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "submit-language-button button",
                  on: { click: _vm.handleMessage }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.submit")) + " ")]
              )
            ])
          ],
          1
        )
      ]
    ),
    _c("div", { on: { click: _vm.closeDialog } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }